export function addElement(el) {
	return {
				type: 'BUILDER_ADD_ELEMENT',
				payload:el
			}
}

export function changeRule(index,key,value) {
	return {
				type: 'BUILDER_CHANGE_RULE',
				payload:{
					index,key,value
				}
			}
}

export function setTag(key,value) {
    return {
        type: 'SET_TAG',
        payload:{
            key,value
        }
    }
}

export function addRow(row) {
	return {
				type: 'BUILDER_ADD_ROW',
				payload:row
			}
}

export function deleteRow(id) {
	return {
				type: 'BUILDER_DELETE_ROW',
				payload:id
			}
}

export function deleteElement(id) {
	return {
				type: 'BUILDER_DELETE_ELEMENT',
				payload:id

			}
}
export function setUiState(changes) {
	return {
				type: 'BUILDER_SET_UI_STATE',
				payload:changes

			}
}

export function setGlobalKeyState(key,value) {
	return {
				type: 'BUILDER_SET_GLOBAL_KEY_STATE',
				payload:{key,value}

			}
}

export function setGlobalTypeState(key,id,changes) {
	return {
				type: 'BUILDER_SET_GLOBAL_TYPE_STATE',
				payload:{key,id,changes}

			}
}

export function setSidebarState(changes) {
	return {
				type: 'BUILDER_SET_SIDEBAR_STATE',
				payload:changes

			}
}

export function setComponentState(id, changes) {
	return {
				type: 'BUILDER_SET_COMPONENT_STATE',
				payload:{id,changes}
			}
}

export function setSelectedTab(tab) {
	return {
				type: 'BUILDER_SET_SIDEBAR_TAB',
				payload:tab
			}
}

export function removeElement(el) {
	return {
		type:'BUILDER_REMOVE_ELEMENT',
		payload:el
	}
}

export function setSelectedRow(id) {
	return {
				type: 'BUILDER_SET_SELECTED_ROW',
				payload:id
			}
}

export function convertToElement(element,el) {
	return {
				type: 'BUILDER_CONVERT_TO_ELEMENT',
				payload:{element,el}
			}
}


export function addRowPlaceholder(newPosition, newSorting) {
	return {
				type: 'BUILDER_ADD_ROW_PLACEHOLDER',
				payload:{newPosition,newSorting}
			}
}

export function moveRow(newPosition, newSorting) {
	return {
				type: 'BUILDER_MOVE_ROW',
				payload:{newPosition, newSorting}
			}
}

export function addPlaceholder(newPosition, newSorting) {
	return {
				type: 'BUILDER_ADD_PLACEHOLDER',
				payload:{newPosition,newSorting}
			}
}

export function moveElement(newPosition, newSorting) {
	return {
				type: 'BUILDER_MOVE_ELEMENT',
				payload:{newPosition, newSorting}
			}
}



// WEBPACK FOOTER //
// ./actions/Builder.js